import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts';
import LanguageSelector from '../components/common/LanguageSelector';
import { useResults } from '../hooks';
import {
  ResultsHeader,
  SummaryTab,
  ProfileTab,
  CareersTab,
  DetailsTab,
} from '../components/results';

const ResultsPage: React.FC = () => {
  const { attemptId } = useParams();
  const { t } = useTranslation();
  const { isRTL, language } = useLanguage();
  const { results, loading, activeTab, setActiveTab } = useResults(attemptId, language);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral">
        <div className="text-center">
          <div className="animate-spin inline-block w-8 h-8 border-3 border-primary border-t-transparent rounded-full mb-3"></div>
          <p className="text-gray-600">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  if (!results) return null;

  return (
    <div className="min-h-screen bg-neutral p-4" dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Language selector - fixed top-right corner */}
      <div className="fixed top-4 right-4 z-50">
        <LanguageSelector />
      </div>

      <div className="max-w-2xl mx-auto">
        <ResultsHeader
          results={results}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />

        <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6">
          {activeTab === 'summary' && <SummaryTab results={results} />}
          {activeTab === 'profile' && <ProfileTab results={results} />}
          {activeTab === 'careers' && <CareersTab results={results} />}
          {activeTab === 'details' && <DetailsTab results={results} />}
        </div>
      </div>
    </div>
  );
};

export default ResultsPage;
